<div class="theme-scope" id="appDarkMode">
  <button mat-stroked-button id="darkMode"  color="primary"(click)="darkmode()"> {{ isDarkMode ? 'Light Mode' : 'Dark Mode' }} </button>
</div>
<router-outlet></router-outlet>
